import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Message} from '../model/message';
import {AppService} from '../app.service';
import { HttpClient } from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {HodnotenieDetailComponent} from '../hodnotenie-detail/hodnotenie-detail.component';
import {Subscription} from 'rxjs';
import {TerminDetailComponent} from '../termin-detail/termin-detail.component';
import {NastenkaPredmetuComponent} from '../../../../sahu/src/app/nastenka-predmetu/nastenka-predmetu.component';
import {NastenkaDetailComponent} from '../nastenka-detail/nastenka-detail.component';
import {PodporaDetailComponent} from '../podpora-detail/podpora-detail.component';
import {Diskusia} from '../model/diskusia';

@Component({
  selector: 'app-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.css']
})
export class MessageItemComponent implements OnInit {

  public loading = false;
  private downloadSubscription: Subscription;

  @Input()
  message: Message;
  @Output()
  onMessageDeleted = new EventEmitter<Message>();

  readonly MESSAGE_NASTENKA_ID = 729;
  readonly MESSAGE_DISKUSNE_FORUM_ID = 1079;

  constructor(
      private http: HttpClient,
      private appService: AppService,
      private dialogService: MatDialog
  ) { }

  ngOnInit() {
  }

  delete(message: Message) {
    this.http
        .delete('/ais/rest/portal/messages/list?id=' + message.id)
        .subscribe(
            () => {
              this.onMessageDeleted.next(message);
            }
        );
  }

  appOpen(message: Message) {
    this.appService.openAppByMessage(message);
  }

  fileSave(message: Message) {
    this.appService.downloadMessageDocument(message);
  }

  isHodnotenie(message: Message) {
    return message.classId === 1080;
  }

  openDetailHodnotenia(message: Message) {
    const dialogRef =
        this.dialogService.open(
            HodnotenieDetailComponent, {
              data: {
                message
              }
            }
        );
  }

    isPredpisPlatby(message: Message) {
      return message.classId === 1004;
    }

  poplatokAction(message: Message) {
    if (this.appService.getPlatobnaBrana()) {
      this.openPlatobnaBrana(message);
    }
    else {
      this.downloadPoplatok(message);
    }
  }

  private downloadPoplatok(message: Message)
  {
    this.loading = true;

    this.downloadSubscription = this.appService.predpisDownloaded
        .subscribe(
            (value) => {
              this.loading = false;
              this.downloadSubscription.unsubscribe();
            }
        );
    this.appService.downloadPoplatokPredpis(message.id, true);
  }

  private openPlatobnaBrana(message: Message)
  {
    this.loading = true;

    this.http.get<{paymentLink: string}>('/ais/rest/portal/portal/payment/' + message.id + '?message=true').subscribe({
      next: (url) => {
        this.loading = false;
        open(url.paymentLink, 'GPW', 'status=0,title=0,top=200,left=200,height=400,width=652,scrollbars=0');
      },
      error: (error) => {
        this.appService.openErrorDialog(error.error.message);
        this.loading = false;
      }
    });
  }

  isTerminHodnotenia(message: Message) {
    return message.classId === 1101;
  }

  terminHodnoteniaAction(message: Message)
  {
    const dialogRef =
        this.dialogService.open(
            TerminDetailComponent, {
              data: {
                message
              }
            }
        );
  }

    isNastenka(message: Message) {
        return message.classId === this.MESSAGE_NASTENKA_ID;
    }

    isDiskusneForum(message: Message) {
        return message.classId === this.MESSAGE_DISKUSNE_FORUM_ID;
    }

    detailNastenkaAction(message: Message) {
      const dialogRef =
          this.dialogService.open(
              NastenkaDetailComponent, {
                data: {
                  message
                }
              }
          );
    }

    detailForumAction(message: Message)
    {
      this.http.get<Diskusia>('/ais/rest/portal/tema-by-message/' + message.id)
        .subscribe({
          next: (diskusia) => {
            this.openDiskusiaDetail(diskusia);
          },
          error: (err) => {
            console.error(err);
          }
        });

    }

    private openDiskusiaDetail(diskusia: Diskusia) {
      const dialogRef =
        this.dialogService.open(
          PodporaDetailComponent, {
            maxHeight: '90vh',
            width: '800px',
            data: {
              diskusia
            }
          }
        );
    }

}
